'use strict';
import multiLocationPickerHtmlUrl from '../../views/directives/multiLocationPickerFb.html';

angular.module('multi-location-picker-fb', [])
    .directive('multiLoocationPickerFb', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                locations: '=ngModel',
                clusterId: '=',
                display: '@display'
            },
            templateUrl: multiLocationPickerHtmlUrl,
            controller: ['$scope','FormService','$ioAlert', function($scope,FormService,$ioAlert) {
                $scope.FormService = FormService;
                $scope.$ioAlert=$ioAlert;
                $scope.unit='mile';

                console.log('clusterId:', $scope.clusterId);
                if ($scope.locations && $scope.locations.length > 0) {
                    $scope.locations = JSON.parse($scope.locations);
                } else {
                    $scope.locations = [];
                }
                $scope.updateGlobalUnit = function(value) {
                    $scope.unit = value;
                    $scope.locations.unit=value;
                }
                $scope.displayMapEdit = ($scope.display && $scope.display == 'edit') ? true : false;
                $scope.addLocation = function() {
                    $scope.locationViewAll();
                    $scope.locations.push({
                        locationName: null,
                        latitude: null,
                        longitude: null,
                        radius: 0,
                        address: {
                            locationName: null
                        },
                        addressFormat: 'city',
                        unit:'mile',
                        editView: true
                    });
                    setTimeout(function() {
                        $scope.drawGoogleMap();
                    });
                }
                $scope.removeLocation = function(location) {
                    var index = $scope.locations.indexOf(location);
                    if (index >= 0) {
                        $scope.locations.splice(index, 1);
                    }
                    $scope.drawGoogleMap();
                }
                $scope.foucusLocation = function(location) {
                    $scope.locationViewAll();
                    var index = $scope.locations.indexOf(location);
                    if (index >= 0) {
                        $scope.focusMap(index);
                    }
                }
                $scope.locationEdit = function(location) {
                    var index = $scope.locations.indexOf(location);
                    $scope.locationViewAll();
                    $scope.locations[index].editView = true;
                }
                $scope.locationView = function(location) {
                    $scope.locationViewAll();
                }
                $scope.locationViewAll = function() {
                    for (var i = 0, len = $scope.locations.length; i < len; i++) {
                        $scope.locations[i].editView = false;
                    }
                }
                $scope.locationViewAll();
            }],
            link: function(scope, element, attrs) {
                var FormService = scope.FormService;
                var $ioAlert=scope.$ioAlert;
                var markers = [];
                var gMapContexts = [];
                var geodecoder = new google.maps.Geocoder();

                function scopeLocationUpdate(gmapContext) {
                    var i = gMapContexts.indexOf(gmapContext);
                    scope.locations[i].address = gmapContext.addressComponents;
                    scope.$apply();
                }

                function updateInputValues(inputBinding, gmapContext) {
                    if (!inputBinding) return;
                    var currentLocation = GmUtility.locationFromLatLng(gmapContext.marker.position);
                    if (inputBinding.latitudeInput) {
                        inputBinding.latitudeInput.val(currentLocation.latitude).change();
                    }
                    if (inputBinding.longitudeInput) {
                        inputBinding.longitudeInput.val(currentLocation.longitude).change();
                    }
                    if (inputBinding.radiusInput) {
                        inputBinding.radiusInput.val(gmapContext.radius).change();
                    }
                    if (inputBinding.locationNameInput) {
                        inputBinding.locationNameInput.val(gmapContext.locationName).change();
                    }
                    scopeLocationUpdate(gmapContext);
                }

                function autosize(gmapContext) {
                    google.maps.event.trigger(gmapContext.map, 'resize');
                    setTimeout(function() {
                        gmapContext.map.setCenter(gmapContext.marker.position);
                    }, 300);
                }

                function displayMarkerWithSelectedArea(index) {
                    GmUtility.setPosition(gMapContexts[index], gMapContexts[index].marker.position, function(context) {
                        var currentLocation = GmUtility.locationFromLatLng(context.location);
                        updateInputValues(context.inputBinding, context);
                        //context.settings.onchanged.apply(gmapContext.domContainer, [currentLocation, context.radius, true, context.addressComponents]);
                    });
                }
                async function validateFbUsCity(cityName, cluster_id) {
                    try {
                        const data = await FormService.validateFbUsCities(cityName, cluster_id);
                        if (data) {
                            console.log("Received data:", data);
                            return data;
                        } else {
                            return null;
                        }
                    } catch (error) {
                        console.log("Error occurred:", error);
                        throw error;
                    }
                }

                var GmUtility = {
                    drawCircle: function(gmapContext, center, radius, options) {
                        if (gmapContext.circle != null) {
                            gmapContext.circle.setMap(null);
                        }
                        if (radius > 0) {
                            radius *= 1609.344;
                            options = $.extend({
                                strokeColor: "#0000FF",
                                strokeOpacity: 0.35,
                                strokeWeight: 2,
                                fillColor: "#0000FF",
                                fillOpacity: 0.20
                            }, options);
                            options.map = gmapContext.map;
                            options.radius = radius;
                            options.center = center;
                            gmapContext.circle = new google.maps.Circle(options);
                            return gmapContext.circle;
                        }
                        return null;
                    },
                    setPosition: function(gMapContext, location, callback) {
                        gMapContext.location = location;
                        gMapContext.marker.setPosition(location);
                        gMapContext.map.panTo(location);
                        this.drawCircle(gMapContext, location, gMapContext.radius, {});
                        if (gMapContext.settings.enableReverseGeocode) {
                            this.updateLocationName(gMapContext, callback);
                        } else {
                            if (callback) {
                                callback.call(this, gMapContext);
                            }
                        }
                    },
                    locationFromLatLng: function(lnlg) {
                        return { latitude: lnlg.lat(), longitude: lnlg.lng() }
                    },
                    addressByFormat: function(addresses, format) {
                        var result = null;
                        for (var i = addresses.length - 1; i >= 0; i--) {
                            if (addresses[i].types.indexOf(format) >= 0) {
                                result = addresses[i];
                            }
                        }
                        return result || addresses[0];
                    },
                    updateLocationName: function(gmapContext, callback) {
                        gmapContext.geodecoder.geocode({
                            latLng: gmapContext.marker.position
                        }, async function(results, status) {
                            if (status == google.maps.GeocoderStatus.OK && results.length > 0) {
                                var address = GmUtility.addressByFormat(results, gmapContext.settings.addressFormat);
                                gmapContext.locationName = address.formatted_address;
                                gmapContext.addressComponents = GmUtility.address_component_from_google_geocode(address.address_components);
                                try {
                                    var fbData;
                                    if(gmapContext.settings.addressFormat==='city') {
                                         fbData = await validateFbUsCity(gmapContext.addressComponents.city, scope.clusterId);
                                    }
                                    gmapContext.addressComponents.facebookDetails=fbData;
                                    gmapContext.addressComponents.unit=scope.unit;
                                    if(gmapContext.settings.addressFormat!=='custom_address' && gmapContext.addressComponents.country!=='US'){
                                        $ioAlert.show('Error!', 'Location Not Belongs To United States Cities And Places, Select The Drop Down As Custom Address', 'error');
                                        return;
                                    }
                                } catch (error) {
                                    $ioAlert.show("Something Went Wrong");
                                    return;
                                }
                                gmapContext.addressComponents.locationName = gmapContext.locationName;
                            } else if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                                return setTimeout(function() {
                                    GmUtility.updateLocationName(gmapContext, callback);
                                }, 1000);
                            }

                            // Callback is invoked after the operation is complete
                            if (callback) {
                                callback.call(this, gmapContext);
                            }
                        });
                    },

                    address_component_from_google_geocode: function(address_components) {
                        var result = {};
                        for (var i = address_components.length - 1; i >= 0; i--) {
                            var component = address_components[i];
                            // Postal code
                            if (component.types.indexOf('postal_code') >= 0) {
                                result.postalCode = component.short_name;
                            }
                            // Street number
                            else if (component.types.indexOf('street_number') >= 0 || component.types.indexOf('premise') >= 0) {
                                result.streetNumber = component.short_name;
                            }
                            // Street name
                            else if (component.types.indexOf('route') >= 0) {
                                result.streetName = component.long_name;
                            }
                            // City
                            else if (component.types.indexOf('locality') >= 0) {
                                result.city = component.long_name;
                            }
                            // District
                            else if (component.types.indexOf('sublocality') >= 0) {
                                result.district = component.short_name;
                            }
                            // State \ Province
                            else if (component.types.indexOf('administrative_area_level_1') >= 0) {
                                result.stateOrProvince = component.long_name;
                            }
                            // State \ Province
                            else if (component.types.indexOf('country') >= 0) {
                                result.country = component.short_name;
                            }
                        }
                        result.addressLine1 = [result.streetNumber, result.streetName].join(' ').trim();
                        result.addressLine2 = '';
                        return result;
                    },
                    indexOfMarker: function(marker) {
                        for (var i = 0, len = gMapContexts.length; i < len; i++) {
                            if (gMapContexts[i].marker === marker) {
                                return i;
                            }
                        }
                        return -1;
                    },
                    indexOfAutoComplete: function(autocomplete) {
                        for (var i = 0, len = gMapContexts.length; i < len; i++) {
                            if (gMapContexts[i].autocomplete === autocomplete) {
                                return i;
                            }
                        }
                        return -1;
                    }
                };

                scope.drawGoogleMap = async function() {
                    var settings = $.fn.locationPickerFb.defaults;
                    var defaultMapLocation = {
                        latitude: 39.838165952339,
                        longitude: -98.5556199
                    };
                    if (scope.locations[0] && scope.locations[0].latitude) {
                        defaultMapLocation.latitude = scope.locations[0].latitude;
                        defaultMapLocation.longitude = scope.locations[0].longitude;
                    }
                    const { Map } = await google.maps.importLibrary("maps");
                    scope.map = new Map(document.getElementById('map'), {
                        zoom: 4,
                        center: new google.maps.LatLng(defaultMapLocation.latitude, defaultMapLocation.longitude),
                        mapTypeId: settings.mapTypeId
                    });
                    scope.infowindow = new google.maps.InfoWindow();

                    for (var i = 0; i < scope.locations.length; i++) {
                        mapAddLocation(scope.locations[i], i);
                    }
                }

                scope.focusMap = function(i) {
                    //gMapContexts[i].marker.setPosition(gMapContexts[i].location);
                    gMapContexts[i].map.panTo(gMapContexts[i].location);
                    //GmUtility.drawCircle(gMapContexts[i], gMapContexts[i].location, gMapContexts[i].radius, {});
                }

                function mapAddLocation(location, i) {
                    var settings = $.fn.locationPickerFb.defaults;
                    gMapContexts[i] = {
                        location: new google.maps.LatLng(location.latitude, location.longitude),
                        locationName: "",
                        map: scope.map,
                        marker: null,
                        circle: null,
                        settings: settings,
                        radius: location.radius,
                        inputBinding: {
                            latitudeInput: null,
                            longitudeInput: null,
                            radiusInput: null,
                            locationNameInput: null
                        },
                        addressFormat: location.addressFormat,
                        geodecoder: new google.maps.Geocoder()
                    };
                    gMapContexts[i].marker = new google.maps.Marker({
                        position: gMapContexts[i].location,
                        map: scope.map,
                        visible: true,
                        draggable: scope.displayMapEdit
                    });

                    if (settings.markerInCenter) {
                        gMapContexts[i].map.addListener("bounds_changed", function() {
                            if (!gmapContext.marker.dragging) {
                                gmapContext.marker.setPosition(gmapContext.map.center);
                                updateInputValues(gmapContext.settings.inputBinding, gmapContext);
                            }
                        });
                        gMapContexts[i].map.addListener("idle", function() {
                            if (!gmapContext.marker.dragging) {
                                displayMarkerWithSelectedArea();
                            }
                        });
                    }

                    if (scope.displayMapEdit) {
                        // binding map events
                        google.maps.event.addListener(gMapContexts[i].marker, 'click', (function(marker, i) {
                            return function() {
                                scope.infowindow.setContent(scope.locations[i].locationName);
                                scope.infowindow.open(scope.map, marker);
                            }
                        })(gMapContexts[i].marker, i));
                        google.maps.event.addListener(gMapContexts[i].marker, "drag", function(event) {
                            var index = GmUtility.indexOfMarker(this);
                            updateInputValues(gMapContexts[index].inputBinding, gMapContexts[index]);
                        });
                        google.maps.event.addListener(gMapContexts[i].marker, "dragend", function(event) {
                            var index = GmUtility.indexOfMarker(this);
                            displayMarkerWithSelectedArea(index);
                        });

                        gMapContexts[i].inputBinding.radiusInput = $("#Radius" + i);
                        gMapContexts[i].inputBinding.locationNameInput = $("#LocationName" + i);
                        gMapContexts[i].inputBinding.latitudeInput = $("#latitude" + i);
                        gMapContexts[i].inputBinding.longitudeInput = $("#longitude" + i);
                        gMapContexts[i].inputBinding.addressFormatInput = $("#addressFormat" + i);
                        if (gMapContexts[i].inputBinding.radiusInput) {
                            gMapContexts[i].inputBinding.radiusInput.on("change", function(e) {
                                var radiusInputValue = $(this).val();
                                if (!e.originalEvent || isNaN(radiusInputValue)) {
                                    return
                                }
                                var eleId = $(this).attr('id');
                                var index = eleId.substring(6);
                                gMapContexts[index].radius = radiusInputValue;
                                GmUtility.setPosition(gMapContexts[index], gMapContexts[index].location, function(context) {
                                    //context.settings.onchanged.apply(gmapContext.domContainer, [GmUtility.locationFromLatLng(context.location), context.radius, false, context.addressComponents]);
                                });
                            });
                        }
                        if (gMapContexts[i].inputBinding.addressFormatInput) {
                            gMapContexts[i].inputBinding.addressFormatInput.on("change", function(e) {
                                var addressFormatVal = $(this).val();
                                var addressFormatArr = addressFormatVal.split(":");
                                var eleId = $(this).attr('id');
                                var index = eleId.substring(13);
                                if(addressFormatArr.length>=2){
                                    gMapContexts[index].settings.addressFormat = addressFormatArr[1];
                                }else{
                                    gMapContexts[index].settings.addressFormat = addressFormatVal;
                                }
                                if(gMapContexts[i].inputBinding.locationNameInput.val()){
                                    blur = true;
                                    setTimeout(function() {
                                        var address = gMapContexts[i].inputBinding.locationNameInput.val();
                                        if (address.length > 5 && blur) {
                                            blur = false;
                                            var eleId = gMapContexts[i].inputBinding.locationNameInput.attr('id');
                                            var index = eleId.substring(12);
                                            gMapContexts[index].geodecoder.geocode({ 'address': address }, function(results, status) {
                                                if (status == google.maps.GeocoderStatus.OK && results && results.length) {
                                                    GmUtility.setPosition(gMapContexts[index], results[0].geometry.location, function(context) {
                                                        updateInputValues(context.inputBinding, context);
                                                    });
                                                }
                                            });
                                        }
                                    }, 500);
                                }
                            });
                        }

                        // Autocomplate
                        if (settings.enableAutocomplete) {
                            var blur = false;
                            gMapContexts[i].autocomplete = new google.maps.places.Autocomplete(gMapContexts[i].inputBinding.locationNameInput.get(0), settings.autocompleteOptions);
                            google.maps.event.addListener(gMapContexts[i].autocomplete, 'place_changed', function (event) {
                                blur = false;
                                var index = GmUtility.indexOfAutoComplete(this);
                                if (index >= 0) {
                                    var place = gMapContexts[index].autocomplete.getPlace();
                                    if (!place.geometry) {
                                        return;
                                    }
                                    GmUtility.setPosition(gMapContexts[index], place.geometry.location, function (context) {
                                        updateInputValues(context.inputBinding, context);
                                        //context.settings.onchanged.apply(gmapContext.domContainer, [GmUtility.locationFromLatLng(context.location), context.radius, false, context.addressComponents]);
                                    });
                                }
                            });
                            if (settings.enableAutocompleteBlur) {
                                gMapContexts[i].inputBinding.locationNameInput.on("change", function (e) {
                                    if (!e.originalEvent) {
                                        return
                                    }
                                    blur = true;
                                });
                                gMapContexts[i].inputBinding.locationNameInput.on("blur", function (e) {
                                    if (!e.originalEvent) {
                                        return
                                    }
                                    setTimeout(function () {
                                        var address = $(this).val();
                                        if (address.length > 5 && blur) {
                                            blur = false;
                                            var eleId = $(this).attr('id');
                                            var index = eleId.substring(12);
                                            gMapContexts[index].geodecoder.geocode({'address': address}, function (results, status) {
                                                if (status == google.maps.GeocoderStatus.OK && results && results.length) {
                                                    GmUtility.setPosition(gMapContexts[index], results[0].geometry.location, function (context) {
                                                        updateInputValues(context.inputBinding, context);
                                                        //context.settings.onchanged.apply(gmapContext.domContainer, [GmUtility.locationFromLatLng(context.location), context.radius, false]);
                                                    });
                                                }
                                            });
                                        }
                                    }, 1000);
                                });
                            }
                        }
                    }
                    // Draw radius
                    GmUtility.drawCircle(gMapContexts[i], gMapContexts[i].location, gMapContexts[i].radius, {});
                }

                $(document).ready(function() {
                    setTimeout(function() {
                        $.fn.locationPickerFb = function(location, options) {
                            //var settings = $.extend({}, $.fn.locationPickerFb.defaults, options);
                        };
                        $.fn.locationPickerFb.defaults = {
                            location: { latitude: null, longitude: null },
                            radius: 0,
                            zoom: 10,
                            mapTypeId: google.maps.MapTypeId.ROADMAP,
                            styles: [],
                            mapOptions: {},
                            scrollwheel: true,
                            enableAutocomplete: true,
                            enableAutocompleteBlur: false,
                            autocompleteOptions: null,
                            addressFormat: 'city',
                            enableReverseGeocode: true,
                            draggable: true,
                            markerIcon: undefined,
                            markerDraggable: true,
                            markerVisible: true
                        };
                        scope.drawGoogleMap();
                    }, 300);
                });
            }
        };
    });